module.exports = __webpack_public_path__ + "static/media/globe-snow.b6369a3c.svg";